import { render, staticRenderFns } from "./FaceCell.vue?vue&type=template&id=76bbd7d2&scoped=true&"
import script from "./FaceCell.vue?vue&type=script&lang=js&"
export * from "./FaceCell.vue?vue&type=script&lang=js&"
import style0 from "./FaceCell.vue?vue&type=style&index=0&id=76bbd7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bbd7d2",
  null
  
)

export default component.exports